module.exports = __webpack_public_path__ + "img/def-food.d7d37bd0.jpg";